import React from 'react';
import SignupSection from './SignupSection';
import UserLoginType from '../../../views/login/UserLoginType';

export default class SignupSection2 extends SignupSection{
	render() {
		const styles={
			display:'inline-block',
			fontWeight:500
		}
  	return(
	<section data-p-ga="" className="mtb child">
		<div className="container">
			 <h2>{this.rb("signup.section.txt.1")}</h2>
			 <h2><span className="hmorg" style={styles}>Hey</span><span className="hmblue" style={styles}>Math!&nbsp;</span>{this.rb("signup.section.txt.2")}</h2>
			 {(() => {
				if(this.props.PLPloggedIn){
					if(this.isFreeTrialAllowed()){
						return(
							<a data-ga="Home - Give your child an Edge - Free Trial" href="#" className="r-btn big-btn" onClick={this.props.startFreeTrial}>Start your Free Trial</a>
						);
					}else{
						return(<span></span>)
					}				
				}else{
					return(
							<div className="col-sm-5 mx-auto text-center">
								<UserLoginType showSignUp={this.props.showSignUp} showNewLoginForm={this.props.showNewLoginForm} from={"Bottom"}/>
							</div>
					);
				}
			})()}
			 
			 
		</div>
	</section> 
  	);
  }


}


// WEBPACK FOOTER //
// ./src/prelogin/src/components/SignupSection2.js